const { __ } = wp.i18n;
/**
 * Container block
 *
 * @since 3.2.13
 */
export const metadata = {
  name: __("HTML", "uipress-lite"),
  moduleName: "uip-custom-html",
  description: __("This block allows you to output your own HTML into the template", "uipress-lite"),
  group: "elements",
  icon: "code",
};
